module.exports = __webpack_public_path__ + "static/drive_revenue_logo-c-671b67567ae4a56ebd7be46fe666561e.png";